import {createSlice} from "@reduxjs/toolkit";
import {
    ActionbarState,
    ActionbarStatus,
    onActionbarStatusChange,
    onActionbarTypeChange,
    onOpenOrderNameChange
} from "../reducers/actionbar-reducers";

export const actionbarSlice = createSlice({
    name: "sidebar",
    initialState: {
        actionbarStatus: ActionbarStatus.DEFAULT,
        openOrderName: undefined,
    } as ActionbarState,
    reducers: {
        changeActionbarType: ((state, action) => onActionbarTypeChange(state, action)),
        changeActionbarStatus: ((state, action) => onActionbarStatusChange(state, action)),
        changeOpenOrderName: ((state, action) => onOpenOrderNameChange(state, action)),
    }
})

export default actionbarSlice.reducer;
export const {changeActionbarType, changeActionbarStatus, changeOpenOrderName} = actionbarSlice.actions;
